import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from '../common/consts/kentico';

const URLElevatoAPI = process.env.REACT_APP_ELEVATO_API;

class JobOfferService {

  async fetchElevatoJobOffers(limit, detailed, language, categories) {
    try {      
      const queryParams = new URLSearchParams();
      limit && queryParams.append('limit', limit);
      detailed && queryParams.append('detailedFiltersInfo', detailed);
      language && queryParams.append('language', language);
      categories && queryParams.append('categories', categories);
      const response = await fetch(
        URLElevatoAPI,
        {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
          },
          body: JSON.stringify({
            method: 'JobOffers',
            params: queryParams.toString(),
          }),
        }
      );
      if (!response.ok) {
        throw new Error(`fetch error, code ${response.status} ${response.statusText}`);
      }
      const resData = await response.json();
      return resData;
    } catch (err) {
      console.log('fetching Elevato job offers error: ', err);
    }
  }

  async fetchJobOffersPageContent() {
    return Client.items()
      .type(KENTICO_TYPES.JOB_OFFER_CONTENT)
      .toPromise();
  }

}

export default new JobOfferService();



// WEBPACK FOOTER //
// ./src/services/JobOffer.service.js